/**
 * Cost of Waiting.
 *
 * A slider over how many years an investment is delayed, two bars comparing
 * investing now against waiting, and the resulting shortfall.
 *
 * The data URL arrives through wp_localize_script (buzzCostWaiting.dataUrl)
 * rather than being hardcoded — the child-theme original pinned a
 * /wp-content/themes/soledad-child/... path and broke when the file moved.
 */
(function () {
	"use strict";

	var CONFIG = window.buzzCostWaiting || {};

	// Used when the JSON cannot be reached, so the widget degrades to
	// something correct rather than sitting on "Loading…" forever. These are
	// the same figures the shipped file carries: $10,000 at 8% over 30 years.
	var FALLBACK = {
		meta: { base_amount: 10000, total_years: 30 },
		scenarios: [
			{ wait_years: 0, future_value: 100627, cost_of_waiting: 0 },
			{ wait_years: 1, future_value: 93173, cost_of_waiting: 7454 },
			{ wait_years: 2, future_value: 86309, cost_of_waiting: 14318 },
			{ wait_years: 3, future_value: 79988, cost_of_waiting: 20639 },
			{ wait_years: 4, future_value: 74174, cost_of_waiting: 26453 },
			{ wait_years: 5, future_value: 68828, cost_of_waiting: 31799 },
			{ wait_years: 6, future_value: 63915, cost_of_waiting: 36712 },
			{ wait_years: 7, future_value: 59403, cost_of_waiting: 41224 },
			{ wait_years: 8, future_value: 55262, cost_of_waiting: 45365 },
			{ wait_years: 9, future_value: 51465, cost_of_waiting: 49162 },
			{ wait_years: 10, future_value: 47987, cost_of_waiting: 52640 }
		]
	};

	function money(n) {
		return "$" + Math.round(n).toLocaleString("en-US");
	}

	/** The scenario for a given delay, or the closest one available. */
	function scenarioFor(data, years) {
		var list = data.scenarios || [];
		var match = null;

		for (var i = 0; i < list.length; i++) {
			if (list[i].wait_years === years) return list[i];
			if (!match || Math.abs(list[i].wait_years - years) < Math.abs(match.wait_years - years)) {
				match = list[i];
			}
		}

		return match;
	}

	function build(widget, data) {
		var scenarios = data.scenarios || [];

		if (!scenarios.length) return;

		var maxWait = scenarios[scenarios.length - 1].wait_years;
		var baseline = scenarioFor(data, 0);

		// The tallest bar across every scenario, so the two bars are scaled
		// against a fixed ceiling and stop jumping as the slider moves.
		var ceiling = baseline ? baseline.future_value : 0;

		var title = widget.getAttribute("data-title") || "Cost of Waiting";
		var start = Math.min(6, maxWait);

		widget.innerHTML =
			'<h3 class="cost-waiting__title"></h3>' +
			'<div class="cost-waiting__slider">' +
			'<input class="cost-waiting__range" type="range" min="0" max="' +
			maxWait +
			'" value="' +
			start +
			'" step="1" aria-label="Years of delay">' +
			"</div>" +
			'<span class="cost-waiting__years"></span>' +
			'<div class="cost-waiting__chart">' +
			'<div class="cost-waiting__bar-wrap">' +
			'<span class="cost-waiting__amount" data-now-amount></span>' +
			'<div class="cost-waiting__bar" data-now-bar></div>' +
			'<span class="cost-waiting__label">Start Now</span>' +
			"</div>" +
			'<div class="cost-waiting__bar-wrap">' +
			'<span class="cost-waiting__amount" data-wait-amount></span>' +
			'<div class="cost-waiting__bar cost-waiting__bar--wait" data-wait-bar></div>' +
			'<span class="cost-waiting__label" data-wait-label></span>' +
			"</div>" +
			"</div>" +
			'<div class="cost-waiting__result">' +
			'<strong class="cost-waiting__loss"></strong>' +
			'<span class="cost-waiting__note"></span>' +
			"</div>";

		widget.querySelector(".cost-waiting__title").textContent = title;

		var range = widget.querySelector(".cost-waiting__range");
		var yearsOut = widget.querySelector(".cost-waiting__years");
		var nowAmount = widget.querySelector("[data-now-amount]");
		var nowBar = widget.querySelector("[data-now-bar]");
		var waitAmount = widget.querySelector("[data-wait-amount]");
		var waitBar = widget.querySelector("[data-wait-bar]");
		var waitLabel = widget.querySelector("[data-wait-label]");
		var loss = widget.querySelector(".cost-waiting__loss");
		var note = widget.querySelector(".cost-waiting__note");

		function update() {
			var years = parseInt(range.value, 10) || 0;
			var s = scenarioFor(data, years);

			if (!s || !baseline) return;

			yearsOut.textContent = years === 1 ? "1 year" : years + " years";

			nowAmount.textContent = money(baseline.future_value);
			waitAmount.textContent = money(s.future_value);

			// Percentages of the fixed ceiling, floored so a tiny bar is still
			// visible rather than collapsing to nothing.
			nowBar.style.height = "100%";
			waitBar.style.height =
				ceiling > 0 ? Math.max(6, (s.future_value / ceiling) * 100) + "%" : "6%";

			waitLabel.textContent = years === 0 ? "No delay" : "Wait " + years + (years === 1 ? " Year" : " Years");

			if (years === 0 || !s.cost_of_waiting) {
				loss.textContent = "No cost — you started today";
				note.textContent = "Every year of delay compounds against you.";
			} else {
				var pct = Math.round((s.cost_of_waiting / baseline.future_value) * 100);

				loss.textContent = "Waiting costs you " + money(s.cost_of_waiting);
				note.textContent =
					years + (years === 1 ? " year" : " year") + " delay = " + pct + "% less wealth";
			}
		}

		range.addEventListener("input", update);
		update();
	}

	function load(widget) {
		var url = CONFIG.dataUrl;

		if (!url) {
			build(widget, FALLBACK);
			return;
		}

		fetch(url)
			.then(function (r) {
				if (!r.ok) throw new Error("HTTP " + r.status);
				return r.json();
			})
			.then(function (data) {
				build(widget, data && data.scenarios ? data : FALLBACK);
			})
			.catch(function () {
				build(widget, FALLBACK);
			});
	}

	function init() {
		var widgets = document.querySelectorAll(".cost-waiting-widget");

		Array.prototype.forEach.call(widgets, load);
	}

	if (document.readyState === "loading") {
		document.addEventListener("DOMContentLoaded", init);
	} else {
		init();
	}
})();
